(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/get-payment-message/get-payment-confirm-message.js') >= 0) return;  svs.modules.push('/components/sport/get-payment-message/get-payment-confirm-message.js'); 'use strict';

var Currency = svs.utils.format.Currency;

var getCost = function getCost(amount) {
  var nonBreakingAmountString = Currency(amount, false).split(' ').join('\xA0');
  return "".concat(nonBreakingAmountString, "\xA0kr");
};


function getPaymentConfirmMessage(_ref) {
  var amount = _ref.amount,
      productName = _ref.productName,
      _ref$marketplaceGroup = _ref.marketplaceGroup,
      marketplaceGroup = _ref$marketplaceGroup === void 0 ? null : _ref$marketplaceGroup,
      _ref$compDesc = _ref.compDesc,
      compDesc = _ref$compDesc === void 0 ? null : _ref$compDesc,
      _ref$competitionSigne = _ref.competitionSignedUp,
      competitionSignedUp = _ref$competitionSigne === void 0 ? null : _ref$competitionSigne,
      _ref$tipsetBombenAmou = _ref.tipsetBombenAmount,
      tipsetBombenAmount = _ref$tipsetBombenAmou === void 0 ? null : _ref$tipsetBombenAmou,
      _ref$bombenCancelable = _ref.bombenCancelable,
      bombenCancelable = _ref$bombenCancelable === void 0 ? false : _ref$bombenCancelable,
      _ref$isRetailer = _ref.isRetailer,
      isRetailer = _ref$isRetailer === void 0 ? false : _ref$isRetailer;

  if (!amount || !productName) {
    throw new Error('Missing required properties `amount` or `productName`');
  }

  var paymentConfirmDialogConfig = {
    price: amount,
    product: productName,
    messages: [],
    title: undefined
  };

  if (marketplaceGroup) {
    paymentConfirmDialogConfig.title = "Vill du betala ett spel p\xE5 ".concat(productName, " f\xF6r ").concat(getCost(amount), " \xE5t ").concat(marketplaceGroup, "?");
    paymentConfirmDialogConfig.messages.push('Kvarvarande pengar återbetalas till medlemmarna.');
  } else if (tipsetBombenAmount) {
    paymentConfirmDialogConfig.title = "Vill du betala ett spel p\xE5 ".concat(productName, " f\xF6r ").concat(getCost(amount), " och ett spel p\xE5 Bomben f\xF6r ").concat(getCost(tipsetBombenAmount), "?");
  } else if (typeof competitionSignedUp === 'boolean') {
    paymentConfirmDialogConfig.title = "Vill du";

    if (!competitionSignedUp) {
      paymentConfirmDialogConfig.title += " anm\xE4la dig till ".concat(compDesc, ",");
    }

    paymentConfirmDialogConfig.title += " l\xE4gga ett spel p\xE5 ".concat(compDesc, " och betala ").concat(getCost(amount), "?");
  }

  if (bombenCancelable) {
    paymentConfirmDialogConfig.messages.push('Spelet går att annullera i 30 minuter, dock senast 1 minut efter spelstopp.');
  } else {
    if (!isRetailer) {
      paymentConfirmDialogConfig.messages.push('Spelet går att annullera.');
    }
  }

  return paymentConfirmDialogConfig;
}

setGlobal('svs.components.sport.getPaymentConfirmMessage', getPaymentConfirmMessage);
 })(window);